import { render, staticRenderFns } from "./AddSelfhelp.vue?vue&type=template&id=46c4c02e"
import script from "./AddSelfhelp.vue?vue&type=script&lang=js"
export * from "./AddSelfhelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports